import app from '../app.first';
import $ from 'jquery';

app.CandidateDashboard = class extends app.Component {
    onReady($this) {
        $('.is-disabled').each(function() {
            $(this).find('input').prop("disabled", true);
            $(this).find('.btn-continue').removeAttr('href');
        })

        $(window).resize(() => {
            if ($(window).width() < 1020) {
                $('#right-navigation').removeClass("is-open");
                $('#right-navigation').addClass("is-closed");
                $('#right-navigation').parent()
                    .find('.js-off-canvas-overlay')
                    .removeClass('is-visible');
                $('#right-navigation').parent()
                    .find('.js-off-canvas-overlay')
                    .removeClass('is-closable');
            }
        })

        $('.application-status-popup-close').click(() => {
            $('.application-status-popup').css('display', 'none');
        })

        let modalOpen = $('.careers-tab');
        let modalClose = $('#modalClose');

        modalOpen.click((e) => {
            e.preventDefault();
            $('.job-modal-container').css('display', 'flex');
        })

        modalClose.click((e) => {
            e.preventDefault();
            $('.job-modal-container').css('display', 'none');
        })
    }
}